import { Alert, AlertIcon, Box, Text } from "@chakra-ui/react";
import { RestricaoAbsoluta } from "store/modules/consultaprevia/types";

/**
 * Vedações que não admitem análise. Vêm em destaque e acima do resto porque
 * mudam a conclusão: não adianta ler parâmetro de uma zona onde a área
 * especial já proíbe edificar.
 */
export const RestricoesAbsolutas = ({
  restricoes
}: {
  restricoes: RestricaoAbsoluta[];
}) => {
  if (!restricoes?.length) return null;

  return (
    <Alert status="error" borderRadius="md" alignItems="flex-start" mb="4">
      <AlertIcon mt="1" />
      <Box>
        <Text fontSize="sm" fontWeight="bold">
          Restrições absolutas neste ponto
        </Text>
        {restricoes.map((restricao) => (
          <Text key={restricao.idAreaEspecial} fontSize="xs" mt="1">
            {`${restricao.sigla} — ${restricao.nome}`}
          </Text>
        ))}
      </Box>
    </Alert>
  );
};
